/* eslint-disable operator-linebreak */
import { createAction } from '@reduxjs/toolkit';
import { IDownloadDocumentRequest, IDocumentDownload } from 'app/interfaces/document-download/document-download.interface';
import {
	IPagination,
	IPortofolioListDetail,
	IPortofolioListItem,
} from '../reducers/PortofolioReducer';

export const GET_PORTOFOLIO_LIST = 'GET_PORTOFOLIO_LIST';
export const SET_PORTOFOLIO_LIST = 'SET_PORTOFOLIO_LIST';
export const GET_LENDER_SUMMARY_HEADER = 'GET_LENDER_SUMMARY_HEADER';
export const SET_LENDER_SUMMARY_HEADER = 'SET_LENDER_SUMMARY_HEADER';
export const GET_PORTOFOLIO_DETAIL = 'GET_PORTOFOLIO_DETAIL';
export const SET_PORTOFOLIO_DETAIL = 'SET_PORTOFOLIO_DETAIL';
export const DOWNLOAD_FACTSHEET = 'DOWNLOAD_FACTSHEET';
export const SET_FACTSHEET = 'SET_FACTSHEET';
export const RESET_FACTSHEET = 'RESET_FACTSHEET';

export interface ILenderSummaryHeaderResponse {
	lenderId: string;
	cashBalance: number;
	outStandingBalance: number;
	estTotalGet: number;
	estInterestGet: number;
	additionalCashBalance: number;
}
export interface IPortofolioParamsRequest {
	name: string;
	loanNumber: string;
	loanStatus: string;
}

export interface IPortofolioListResponse {
	portofolioList: IPortofolioListItem[];
	pagination: IPagination;
}

export interface IPortofolioDetailRequest {
	propertyLenderId: string;
	page: number;
	limit: number;
}

export const getLenderSummaryHeaderAction = createAction(
	GET_LENDER_SUMMARY_HEADER
);

export const setLenderSummaryAction =
	createAction<ILenderSummaryHeaderResponse>(SET_LENDER_SUMMARY_HEADER);

export const getPortofolioListAction =
	createAction<IPortofolioParamsRequest>(GET_PORTOFOLIO_LIST);

export const setPortofolioListAction =
	createAction<IPortofolioListResponse>(SET_PORTOFOLIO_LIST);

export const getPortofolioDetailAction = createAction<IPortofolioDetailRequest>(
	GET_PORTOFOLIO_DETAIL
);

export const setPortofolioDetailAction = createAction<IPortofolioListDetail>(
	SET_PORTOFOLIO_DETAIL
);

export const downloadFactsheetAction = createAction<IDownloadDocumentRequest>(
	DOWNLOAD_FACTSHEET
);

export const setFactsheetAction = createAction<IDocumentDownload>(
	SET_FACTSHEET
);

export const resetFactsheetAction =
    createAction(RESET_FACTSHEET);
